import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { faSearchPlus, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute} from '@angular/router';
import { MatDialog} from '@angular/material/dialog';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { ImageViewerConfig } from 'ngx-image-viewer';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { ActivityStoreFacade } from "../../../common/facade/ActivityStoreFacade";
import { BlobStorageFacade } from '../../../common/facade/BlobStorageFacade';
import { ChecklistFacade } from '../../../common/facade/ChecklistFacade';
import { TaskFacade } from "../../../common/facade/TaskFacade";
import { CatalogDetInfo } from "../../../common/model/dictionary/CatalogDetInfo";

@Component({
    selector: "app-reportstoreinstruction",
    templateUrl: "./reportstoreinstruction.component.html",
    styleUrls: ['./reportstoreinstruction.component.css']
})

export class ReportStoreInstructionComponent
    implements OnInit {

    //Properties and Attributes
    lblSearch = res.Search;
    lblDownload = res.Download;
    lblDownloadChangeLevelInstruction = res.DownloadChangeLevelInstruction;
    lblInvoice = res.Reference;
    lblLevelOneTab = res.LevelOneTab;
    lblLevelTwoCard = res.LevelTwoCard;
    lblLevelThreeTitle = res.LevelThreeTitle;
    lblInstruction = res.Instruction;
    lblAnswer = res.Answer;
    lblComments = res.Comments;
    lblPhotos = res.Photos;
    lblDuration = res.Action;
    lblGenerating = res.Generating;
    lblAction = res.Action;
    lblCommitmentDate = res.CommitmentDate;

    faFilePdf = faFilePdf
    @ViewChild('tableInstructions') tableInstructions: DatatableComponent;
    _catDetTaskTypeId = 0
    _activStoreId: number=0;
    _storeName: String="";
    _titleActivity: String = ""
    _duration: String =""
    _taskId = 0
    _storeId = 0
    loading = false;
    messageLoader = '';
    message = '';
    rows: any = [];
    filteredData = [];
    isChecklist = false
    lsSections = []
    lsInstructions = []

    //PDF
    imagesActivity: any = []
    lMarginHeader=10 //left margin in mm
    lMargin=20 //left margin in mm
    rMargin=10 //right margin in mm
    pdfInMM=210  // width of A4 in mm
    y = 10

    //Modal
    modalRef: BsModalRef
    configModal = {
        ignoreBackdropClick: true // si es false se cierra el modal dar clic fuera de el
    }
    faSearchPlus = faSearchPlus
    photos: any = []
    photos_gallery: any = []
    asiDto: any = []
    imageIndexOne = 0;
    imageIndexTwo = 0;
    configImageViewer: ImageViewerConfig = {customBtns: []};

    alerts: any[] = [];
    _isChangeLevel: boolean = false;

    //Constructor
    constructor(
        private _facade: ActivityStoreFacade,
        private _facadeChecklist: ChecklistFacade,
        private _facadeBlobStorage: BlobStorageFacade,
        private _facadeTaskFacade: TaskFacade,
        private _route: ActivatedRoute,
        public dialog: MatDialog,
        private modalService: BsModalService,
        public strings: Strings
    ) 
    {
    }

    //EventHandlers
    ngOnInit() {
        const navigation = this._route.queryParams.subscribe(params => {
            this._activStoreId = Number(params["pActvStrd"])
            this._storeName = String(params["pStoreName"])
            this._titleActivity = String(params["pTitleActivity"])
            this._catDetTaskTypeId = Number(params["pCtDtTskType"])
            this._taskId = Number(params["pTi"])
            this._storeId = Number(params["pSi"])
            
        });

        if (this._catDetTaskTypeId == 106 || this._catDetTaskTypeId == 107
            || this._catDetTaskTypeId == 108 || this._catDetTaskTypeId == 109 || this._catDetTaskTypeId == 111 || this._catDetTaskTypeId == 111 || this._catDetTaskTypeId == 115 || this._catDetTaskTypeId == 117)
        {
            this.isChecklist = true   
        }
        if (this._catDetTaskTypeId == CatalogDetInfo.CatDetLevelChange || this._catDetTaskTypeId == CatalogDetInfo.CatDetLevelChangeUSA){
            this._isChangeLevel = true;
        }
        
        this.loading = true;
        this.messageLoader = this.strings.GetText(res.Loading);
        
        this._facade.GetDetail(this._activStoreId).subscribe(result => {
            if(result.completed)
            {
                let lsSectionsAux = []
                this.rows = result.data;
                this.filteredData = result.data;
                this._duration = result.message;

                result.data.forEach(inst => {
                    let section = lsSectionsAux.find(x => x.checkSectId == inst.checklistSections[0].checkSectId)
                    if (section == null)
                    {
                        lsSectionsAux.push(inst.checklistSections[0])
                    }
                    lsSectionsAux.forEach(section => {
                        if (section.checkSectId == inst.checklistSections[0].checkSectId)
                        {
                            if (section.instructions == null)
                            {
                                section.instructions = []
                            }
                            section.instructions.push(inst)
                        }
                    });
                });

                var totalRound = 0.0

                lsSectionsAux.forEach(section => {
                    let objSection = {
                        sectionTitle: "",
                        sectionWeight: 0
                    }
                    let totalInstruction = section.instructions.filter(x => x.answerValue != -1).length;
                    let totalAnswerValue = section.instructions.filter(x => x.answerValue != -1).reduce((sum, current) => sum + current.answerValue, 0);;
                    let totalMaxAnswerValue = section.instructions.filter(x => x.answerValue != -1).reduce((sum, current) => sum + current.maxAnswerValue, 0);;

                    objSection.sectionTitle = section.title

                    let totalSection = 
                        (
                            (
                                (totalAnswerValue / totalMaxAnswerValue) * 100
                            ) * section.sectionWeight
                        )
                        
                    objSection.sectionWeight = Number(totalSection.toFixed());
                    this.lsSections.push(objSection)
                    totalRound += totalSection
                });

                let secionFinal = {
                    sectionTitle: "",
                    sectionWeight: ""
                }
                secionFinal.sectionTitle = "TOTAL"
                secionFinal.sectionWeight = totalRound.toFixed()
                this.lsSections.push(secionFinal)
            }
            this.loading = false;
        }, error => 
        {
            this.add(error)
            this.loading = false;
        });
    }

    onViewDetail(activStoreId:any)
    {
        alert(activStoreId);
    }

    //Filtro para la tabla de busqueda
    updateFilter(event) {
        let val = event.target.value.toLowerCase();

        let keys = Object.keys(this.filteredData[0]);
        this.rows = this.filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) 
                {
                    return true;
                }
            }
        });

        this.tableInstructions.offset = 0;
    }

    // Abrir modal donde se muestran todas las fotos de la instruccion seleccionada
    openModal(template: TemplateRef<any>, asiDto: any) 
    {
        this.loading = true;
        this.messageLoader = this.strings.GetText(res.GettingImages);
        this.photos_gallery = []
        this.imageIndexOne = 0

        // llamar el servicio que obtiene todas las imagenes de la instruccion seleccionada
        this._facadeBlobStorage.GetThumbnailByActivStoreInstId(asiDto.activStoreInstId).subscribe(result => {
            if(result.completed)
            {
                this.photos = result.data
                this.asiDto = asiDto

                for (let photo of this.photos)
                {
                //  photo.thumbnailBase64 = 'data:image/png;base64,' + photo.thumbnailBase64;
                  photo.fileDataBase64 = 'data:image/png;base64,' + photo.fileDataBase64;
                  this.photos_gallery.push(photo.fileDataBase64)
                }

                this.modalRef = this.modalService.show(
                    template,
                    Object.assign({}, { class: 'gray modal-lg' }, this.configModal)
                );
                this.loading = false;
            }
            else
            {
                this.loading = false
                this.add(this.strings.GetText(res.FailedToGetImages))
            }
            }, error => 
            {
                this.loading = false;
                this.add(this.strings.GetText(res.FailedToGetImages))
            });
    }

    convertBase64ToBlobData(base64Data: string, contentType: string = 'image/png', sliceSize = 512) {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    createPDF(_isLevenChange: Boolean = false)
    {
        this.imagesActivity = []
        this.loading = true
        this.messageLoader = this.strings.GetText(res.Generating) + " PDF"

        if (_isLevenChange){
            this._facadeTaskFacade.GetPdf(this._taskId, this._storeId).subscribe(result => {
                if (result.completed) {
                    try {
                        if (result.data != null){
                            const filename = "ChangeLevelInstruction.pdf";
                            const blobData = this.convertBase64ToBlobData(result.data);
                            var nav: any = window.navigator;

                            if (nav && nav.msSaveOrOpenBlob) { //IE
                                nav.msSaveOrOpenBlob(blobData, filename);
                            } else { // chrome
                                const blob = new Blob([blobData], { type: 'application/octet-stream' });
                                const url = window.URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = filename;
                                link.click();
                            }
                        } else {
                            this.add(this.strings.GetText(res.AlertCouldNotGetChangeLevelInstruction))
                        }
                    }
                    catch
                    {
                        this.add(this.strings.GetText(res.AlertOperationCouldNotBeCompleted))
                    }
                }
                else {
                    this.add(result.message)
                }

                this.loading = false
            });
        } else {
            this._facade.GetReportPdf(this._activStoreId, this.strings.getLanguageIsSpanish()).subscribe(result => {
                if (result.completed) {
                    try {
                        const filename = "Report.pdf";
                        const blobData = this.convertBase64ToBlobData(result.data);
                        var nav: any = window.navigator;

                        if (nav && nav.msSaveOrOpenBlob) { //IE
                            nav.msSaveOrOpenBlob(blobData, filename);
                        } else { // chrome
                            const blob = new Blob([blobData], { type: 'application/octet-stream' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.download = filename;
                            link.click();
                        }
                    }
                    catch
                    {
                        this.add(this.strings.GetText(res.AlertOperationCouldNotBeCompleted))
                    }

                }
                else {
                    this.add(result.message)
                }

                this.loading = false
            }, error =>
            {
                this.loading = false
                this.add(error)
            }
            );
        }
    }

    // añadir alert
    add(message: String): void {
        this.alerts = []
        this.alerts.push({
            type: 'danger',
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
      }

    validatePDFPage() : boolean
    {
        var pdfHighInMM=287;  // width of A4 in mm
        if (this.y <= pdfHighInMM)
        {
            return true
        }
        else
        {
            this.y = 20
            return false
        } 
    }
}